// eslint-disable-next-line import/no-unresolved
const formHelpers = require('base/checkout/formErrors');

function assingNewsletterEvents() {
    const newsletterWithCheckboxPopUp = $('#newsletterWithCheckboxPopUp');
    newsletterWithCheckboxPopUp.submit((e) => {
        const $form = $(e.target);
        e.preventDefault();

        if (newsletterWithCheckboxPopUp.find('#newsletter-terms-modal')[0].checked) {
            $.spinner().start();
            const url = $form.attr('action');
            const formData = {
                format: 'ajax',
                hpEmailSignUp: newsletterWithCheckboxPopUp.find('#hpEmailSignUpPop').val(),
            };

            $.ajax({
                url,
                type: 'post',
                dataType: 'json',
                data: formData,
                success(data) {
                    if (data.error && data.fieldErrors.length) {
                        data.fieldErrors.forEach((error) => {
                            if (Object.keys(error).length) {
                                formHelpers.loadFormErrors('#newsletterWithCheckboxPopUp', error);
                                let titleError;

                                try {
                                    titleError = JSON.parse(error.hpEmailSignUp).title;
                                } catch (err) {
                                    titleError = error.hpEmailSignUp;
                                }

                                newsletterWithCheckboxPopUp
                                    .find('.input-group > .invalid-feedback')
                                    .fadeTo(0, 1)
                                    .html(titleError);
                                newsletterWithCheckboxPopUp
                                    .find('.newsletter-inputs-container > .input-group input')
                                    .addClass('is-invalid');
                            }
                        });
                    } else {
                        newsletterWithCheckboxPopUp
                            .find('#hpEmailSignUp')
                            .parent()
                            .html(`<span>${data.subscriptiondMsgBody}</span>`);
                        newsletterWithCheckboxPopUp
                            .find('.newsletter-inputs-container > .invalid-feedback')
                            .fadeTo(0, 0);
                        newsletterWithCheckboxPopUp
                            .find('.newsletter-inputs-container > .input-group input')
                            .removeClass('is-invalid');
                        $('#hpEmailSignUpPop').val('');
                        $('.success-feedback').text(data.subscriptiondMsgBody);
                    }
                    $.spinner().stop();
                },
                error(err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                    $.spinner().stop();
                },
            });
        } else {
            newsletterWithCheckboxPopUp
                .find('.newsletter-inputs-container > .invalid-feedback')
                .fadeTo(0, 1);
            $('#newsletter-terms-modal').addClass('is-invalid');
        }
        return false;
    });
}

module.exports = () => {
    $(document.body).on('click', '.consent-tracking .affirm', () => {
        const newsletterModal = $('#newsletterModal');
        if (newsletterModal.length) {
            setTimeout(() => {
                newsletterModal.modal('show');
                assingNewsletterEvents();
            }, 1000);
        }
    });
};
